// extracted by mini-css-extract-plugin
export var bundleProductCardPadding = "ImageContainer-module--bundleProductCardPadding--081e7";
export var buttons = "ImageContainer-module--buttons--a5420";
export var closeButton = "ImageContainer-module--closeButton--4654f";
export var fullHeight = "ImageContainer-module--fullHeight--8a249";
export var galleryPadding = "ImageContainer-module--galleryPadding--d7a6e";
export var image = "ImageContainer-module--image--5ddc4";
export var imageContainer = "ImageContainer-module--imageContainer--5fbf6";
export var landscape = "ImageContainer-module--landscape--d3952";
export var moduleImage = "ImageContainer-module--moduleImage--244aa";
export var portrait = "ImageContainer-module--portrait--c5c9b";
export var productCardPadding = "ImageContainer-module--productCardPadding--7f1fb";
export var square = "ImageContainer-module--square--6dc37";
export var videoModal = "ImageContainer-module--videoModal--227e8";
export var wide = "ImageContainer-module--wide--35528";